import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, AlertCircle, MailCheck } from "lucide-react";
import AuthLayout from "../components/auth/AuthLayout";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setLoading(false); }
  };

  if (sent) {
    return (
      <AuthLayout title="Check your email" subtitle="If an account exists for this address, we've sent a reset link." testid="forgot-success">
        <div className="flex flex-col items-center text-center py-2">
          <div className="w-16 h-16 rounded-full bg-emerald2-50 flex items-center justify-center mb-4">
            <MailCheck size={28} className="text-emerald2-dark" />
          </div>
          <p className="t-body text-slate2 mb-6">The reset link expires in 1 hour. Check spam if it doesn't arrive within a minute.</p>
          <Link to="/login" className="btn btn-secondary btn-block">Back to sign in</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we'll send you a reset link."
      testid="forgot-page"
      footer={<Link to="/login" className="text-white/70 hover:text-white">← Back to sign in</Link>}
    >
      {err && (
        <div className="mb-4 p-3 rounded-md text-sm flex items-start gap-2" style={{ background: "rgba(239,68,68,0.06)", color: "#991B1B", border: "1px solid #FECACA" }}>
          <AlertCircle size={16} className="mt-0.5" />{err}
        </div>
      )}
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="label2">Email address<span className="req">*</span></label>
          <input type="email" required className="input2" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
        </div>
        <button type="submit" className="btn btn-primary btn-block" disabled={loading} data-testid="forgot-submit">
          {loading ? <><Loader2 size={16} className="animate-spin" />Sending…</> : "Send reset link"}
        </button>
      </form>
    </AuthLayout>
  );
}
